import axiosInstance from "./AxiosInstance"

const API_URL = "/batchquizhistories"
const BATCH_QUIZ_HISTORIES_PAGE_CAP = 100
const BATCH_QUIZ_HISTORIES_DEFAULT_LIMIT = 10

// Get all batch quiz histories with pagination, search, searchField, courseId, and trainerId filters
export const getBatchQuizHistories = async (
  limit = 10, 
  page = 1, 
  search = "", 
  searchField = "",
  courseId = "", 
  trainerId = "", 
  quizId = "", 
  includeTotal = true
) => {
  try {
    const safeLimit = Math.max(1, Math.min(BATCH_QUIZ_HISTORIES_PAGE_CAP, Number.parseInt(limit, 10) || BATCH_QUIZ_HISTORIES_DEFAULT_LIMIT))
    const safePage = Math.max(1, Number.parseInt(page, 10) || 1)
    
    // Build query parameters
    let queryParams = `?limit=${safeLimit}&page=${safePage}`
    
    // Add search parameter if provided
    if (search) {
      queryParams += `&search=${encodeURIComponent(search)}`
    }
    
    // Add searchField parameter if provided
    if (searchField) {
      queryParams += `&searchField=${searchField}`
    }
    
    // Add courseId filter if provided
    if (courseId) {
      queryParams += `&courseId=${courseId}`
    }
    
    // Add trainerId filter if provided
    if (trainerId) {
      queryParams += `&trainerId=${trainerId}`
    }
    
    // Add quizId filter if provided
    if (quizId) {
      queryParams += `&quizId=${quizId}`
    }
    
    // Add includeTotal parameter
    queryParams += `&includeTotal=${includeTotal}`
    
    const response = await axiosInstance.get(`${API_URL}${queryParams}`)
    return {
      data: response.data?.data || [],
      pagination: response.data?.pagination || {},
    }
  } catch (error) {
    console.error("Error fetching batch quiz histories", error)
    throw error
  }
}

// Create a new batch quiz history
export const createBatchQuizHistory = async (assignmentData) => {
  try {
    const response = await axiosInstance.post(API_URL, assignmentData)
    return response.data
  } catch (error) {
    console.error("Error creating batch quiz history", error)
    throw error
  }
}

// Update a batch quiz history by ID
export const updateBatchQuizHistory = async (assignmentId, assignmentData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${assignmentId}`, assignmentData)
    return response.data
  } catch (error) {
    console.error("Error updating batch quiz history", error)
    throw error
  }
}

// Delete a batch quiz history by ID
export const deleteBatchQuizHistory = async (assignmentId) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${assignmentId}`)
    return response.data
  } catch (error) {
    console.error("Error deleting batch quiz history", error)
    throw error
  }
}

// Get a batch quiz history by ID
export const getBatchQuizHistoryById = async (assignmentId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${assignmentId}`)
    return {
      data: response.data.data,
      status: response.status,
      message: response.data.message,
    }
  } catch (error) {
    console.error("Error fetching batch quiz history details", error)
    throw error
  }
}

export default {
  getBatchQuizHistories,
  createBatchQuizHistory,
  updateBatchQuizHistory,
  deleteBatchQuizHistory,
  getBatchQuizHistoryById,
}